import { ReactElement } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: ReactElement;
  color?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error';
  elevation?: number;
  gradient?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color = 'primary',
  elevation = 2,
  gradient = false,
}) => {
  return (
    <Paper
      elevation={elevation}
      sx={(theme) => ({
        p: 2.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        background: gradient
          ? `linear-gradient(135deg, ${alpha(theme.palette[color].main, theme.palette.mode === 'dark' ? 0.14 : 0.08)} 0%, ${alpha(theme.palette[color].main, 0)} 100%)`
          : 'background.paper',
        height: '100%',
      })}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="h2" fontWeight={700} color="text.primary">
            {value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
        </Box>
        <Box
          sx={(theme) => ({
            display: 'grid',
            placeItems: 'center',
            width: 50,
            height: 50,
            borderRadius: 1.5,
            color: `${color}.main`,
            backgroundColor: alpha(
              theme.palette[color].main,
              theme.palette.mode === 'dark' ? 0.22 : 0.12
            ),
            '& .MuiSvgIcon-root': {
              fontSize: 30,
            },
          })}
        >
          {icon}
        </Box>
      </Box>
    </Paper>
  );
};

export default StatCard;
